import { UserPerceivedLoadTimingContext } from "@faire/web--source/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import React, { useCallback, useContext } from "react";
import styled from "styled-components";

export const BrandPageImageErrorFallback = () => {
  const { refCallback } = useContext(UserPerceivedLoadTimingContext);

  const ref = useCallback(
    (element: HTMLDivElement | null) => {
      refCallback?.(element, {
        status: "error",
        error: "failed_to_render_image",
      });
    },
    [refCallback]
  );
  return (
    <EmptyImage ref={ref} data-test-id="brand-page-image-rsc-error-fallback" />
  );
};

const EmptyImage = styled.div`
  width: 100%;
  aspect-ratio: 1;
`;
